export enum PageListComponentType {
  FLASH = 'flash',
  FLAT = 'flat',
}
